<template>
	<div v-if="question">
	<div class="container container--narrow pdt-50">
		<question-tag
			:correctRate="question.avgSolveTime"
			:avgSolveTime="question.avgSolveTime"
			:level="paperLevel"
		></question-tag>
			<div v-if="groupQuestionCount === 1">
				<div class="mgt-16 t-subtitle6 t-line-h-28 font-rn">
					<vue-mathjax :formula="question.contents.text" v-if="question.useMathjax"></vue-mathjax>
					<div v-else>
						{{ question.contents.text }}
					</div>
				</div>
					<div class="mgt-24" v-if="question && question.contents && question.contents.image">
						<img :src="question.contents.image" alt="" class="b-radius4">
				</div>
				<div class="mgt-24 t-subtitle3 font-rn">
					{{isCorrect() ? $t('1270') : $t('1271')}}
				</div>
			<div class="mgt-24">
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 mdc-text-field--disabled disabled--Updated"
					data-mdc-auto-init="MDCTextField"  :id="`answerEl`">
					<span class="mdc-notched-outline">
						<span class="mdc-notched-outline__leading"></span>
						<span class="mdc-notched-outline__notch">
							<!-- <span class="mdc-floating-label" id="my-label-id">{{$t('1254')}}</span> -->
						</span>
						<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input t-body6 font-r z-99" type="text"
									maxlength="50"
									autocomplete="off"
									v-model="textAnswer"
									readonly disabled />
				</label>
			</div>
				<div v-if="!isCorrect()">
					<div class="divider mgt-16 mgb-16"></div>
						<div class="mgt-24 t-subtitle3 font-rn">
							{{$t('1272')}}
						</div>
						<div class="bg-quizGray b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 mgt-24  box-54">
							<div class="d-flex align-items-center">
								<div class="t-body6 t-color-quizBlack font-r flex-grow-1">
									{{textCorrect}}
								</div>
							</div>
						</div>
					</div>
				</div>
		<div v-else>
			<div class="mgt-16 t-body1 t-line-h-28 ">
				{{groupQuestionTitle}}
			</div>
		<div class="mgt-24">
			<div class="mdc-card pda-24 bg-documentGray position-relative grouped-card">
				<div class="mgb-24 t-subtitle6 t-line-h-28 font-rn">
					<vue-mathjax :formula="question.contents.text" v-if="question.useMathjax"></vue-mathjax>
					<div v-else>
						{{ question.contents.text }}
					</div>
					</div>
					<div class="mgt-24" v-if="question && question.contents && question.contents.image">
						<img :src="question.contents.image" alt="" class="b-radius4">
				</div>
				<div class="mgt-24 t-subtitle3 font-rn">
							{{isCorrect() ? $t('1270') : $t('1271')}}
					</div>
			<div class="mgt-24">
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 mdc-text-field--disabled"
					data-mdc-auto-init="MDCTextField"  :id="`answerEl`">
					<span class="mdc-notched-outline">
						<span class="mdc-notched-outline__leading"></span>
						<!-- <span class="mdc-notched-outline__notch">
							<span class="mdc-floating-label" id="my-label-id">{{$t('1254')}}</span>
						</span> -->
						<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input t-body6 font-r z-99" type="text"
									maxlength="50"
									autocomplete="off"
									v-model="textAnswer"
									readonly disabled />
				</label>
			</div>
				<div v-if="!isCorrect()">
					<div class="divider mgt-16 mgb-16"></div>
						<div class="mgt-24 t-subtitle3 font-rn">
							{{$t('1272')}}
						</div>
						<div class="bg-quizGray b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 mgt-24  box-54">
							<div class="d-flex align-items-center">
								<div class="t-body6 t-color-quizBlack font-r flex-grow-1">
									{{textCorrect}}
								</div>
							</div>
						</div>
					</div>
			</div>
			</div>
				</div>
			<question-tip v-if="question && question.tip" :tip="question.tip" :marginType="groupQuestionCount === 1 ? true :false"/>
		</div>
		<question-feedback
			:commonFeedback="question.feedback.common"
			:correctFeedback="question.feedback.correct"
			:incorrectFeedback="question.feedback.incorrect"
			:videoFeedback="question.feedback.video"
			:feedbackStatus="feedback"
			:correct="question.correct"
			:questionId="question.questionId"
			:currentGroupIndex="currentGroupIndex"
		></question-feedback>
	</div>
</template>

<script>
/**
 * 범위입력형 문항 피드백 컴포넌트(fill in the range type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import QuestionFeedback from './QuestionFeedback.vue'
import {questionMixin} from '@/mixins/question.js'

export default {
	props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'paperLevel', 'feedback', 'currentGroupIndex'],
	data() {
		return {
			textAnswer: '',
			textCorrect: ''
		}
	},
	components: {
		'question-tag': QuestionTag,
		'question-tip': QuestionTip,
		'question-feedback': QuestionFeedback
	},

	mixins: [questionMixin],

	watch: {
        question (newVar, oldVar) {
            // console.log('setedAnswer=>newVar',newVar)
            // console.log('setedAnswer=>oldVar',oldVar)
            this.textAnswer = JSON.parse(JSON.stringify( Math.floor(this.question.textAnswer)))
            let temp = this.question.textCorrect?this.question.textCorrect.split('-'):[];
            this.textCorrect =temp.map(val=>Math.floor(val)).join('-')
        }
    },
	
	mounted() {
		this.textAnswer = Math.floor(this.question.textAnswer)
		let temp = this.question.textCorrect?this.question.textCorrect.split('-'):[];
		this.textCorrect =temp.map(val=>Math.floor(val)).join('-')
		
		const textField = new MDCTextField(document.getElementById(`answerEl`))
	},
}
</script>
<style scoped>
.question-choices .choice .correct-icon {
	min-width: 32px;
	height: 32px;}
</style>
